'use client'

/**
 * Only use this function AFTER you are certain that the DOM is fully loaded and DOM events have been attached.
 * It is NOT guaranteed that this function will return the correct value if called before the DOM is fully loaded.
 */
export function __unsafe__client__isInReactNativeWebViewRuntime() {
  return 'ReactNativeWebView' in window && window.ReactNativeWebView !== undefined
}
